<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input
        v-model="listQuery.keyword"
        placeholder="请输入关键字"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-select
        v-model="listQuery.status"
        placeholder="状态"
        style="width: 120px"
        class="filter-item"
        clearable
      >
        <el-option
          v-for="item in BRAND_STATUS"
          :key="item.key"
          :label="item.value"
          :value="item.key"
        />
      </el-select>
      <Category
        :value="listQuery.category"
        @valueFunc="getCategoryValueFunc"
        type="queryCategory"
        :styleRef="{ width: '200px', marginRight: '10px' }"
        class="filter-item"
      />
      <el-button
        class="filter-item"
        type="primary"
        icon="el-icon-search"
        @click="handleFilter"
        >搜索</el-button
      >
      <el-button
        class="filter-item"
        type="primary"
        @click="checkDialogFormVisible(true, {}, 'CREATE')"
        >新增</el-button
      >
    </div>

    <div style="margin-bottom: 5px">品牌数量:{{ total }}</div>

    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      size="small"
      border
      fit
      highlight-current-row
    >
      <el-table-column
        align="center"
        prop="id"
        label="ID"
        width="95"
      ></el-table-column>
      <el-table-column
        label="商户名称"
        align="center"
        prop="mchName"
        width="100"
      ></el-table-column>
      <el-table-column
        label="名称"
        align="center"
        prop="name"
        width="100"
      ></el-table-column>
      <el-table-column label="类目" align="center" prop="caterotyDescr" width="200">
        <template slot-scope="scope">
          {{ scope.row.caterotyDescr }}
        </template>
      </el-table-column>
      <el-table-column label="品牌logo" align="center" prop="logo" width="200">
        <template slot-scope="scope">
          <el-image
            :src="getTableThumbnailImg(scope.row.logo)"
            fit="cover"
          ></el-image>
        </template>
      </el-table-column>
      <el-table-column
        label="品牌介绍"
        align="center"
        prop="content"
      ></el-table-column>
      <el-table-column
        label="认证通过时间"
        align="center"
        prop="checkedTime"
        width="160"
      >
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ formatApiDate(scope.row.checkedTime) }}</span>
        </template>
      </el-table-column>
      <el-table-column class-name="status-col" label="状态" align="center">
        <template slot-scope="scope">
          <el-tag
            style="color: #FFF;"
            :color="getValue(BRAND_STATUS_CSS, scope.row.status)"
            >{{ getValue(BRAND_STATUS, scope.row.status) }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column align="center" prop="ctdate" label="创建时间" width="160">
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ formatApiDate(scope.row.ctdate) }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="mddate" label="修改时间" width="160">
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ formatApiDate(scope.row.mddate) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        width="160"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <el-button
            type="success"
            size="mini"
            @click="checkDialogFormVisible(true, scope.row, 'UPDATE')"
            >编辑</el-button
          >
          <el-button
            type="warning"
            size="mini"
            @click="checkExamineVisible(true, scope.row)"
            :disabled="BRAND_STATUS_VAL.TO_BE_REVIEWED !== scope.row.status"
            >审核</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50, 100]"
        :page-size="listQuery.pageSize"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <!--    编辑和新增-->
    <el-dialog
      :title="DIALOG_TITLE_TYPE[dialogType]"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="40%"
    >
      <el-form
        ref="form"
        :rules="rules"
        :model="form"
        label-position="left"
        label-width="150px"
        style="width: 80%; margin-left:50px;"
      >
        <el-form-item label="品牌名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入" />
        </el-form-item>
        <el-form-item label="所属类目" prop="category">
          <Category
            :value="form.category"
            @valueFunc="getCategoryValueFunc"
            type="formCategory"
            :styleRef="{ width: '100%' }"
          />
        </el-form-item>
        <el-form-item label="店铺LOGO" prop="logo">
          <UploadList
            :typeProps="UPLOAD_IMG_TYPE.BRAND"
            @valueFunc="getImgsValueFunc"
            paramsType="brandLogo"
            :model="form.logo"
            :maxCount="1"
          />
        </el-form-item>
        <el-form-item label="品牌介绍" prop="content">
          <el-input
            type="textarea"
            v-model="form.content"
            placeholder="请输入"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="checkDialogFormVisible(false, {}, '')"
          >取消</el-button
        >
        <el-button
          type="primary"
          @click="saveAddOrEditData"
          :loading="btnLoading"
          >确定</el-button
        >
      </div>
    </el-dialog>

    <!--    审核-->
    <el-dialog
      title="审核"
      :visible.sync="examineVisible"
      :close-on-click-modal="false"
      width="40%"
    >
      <el-form
        ref="examineForm"
        :rules="examineRules"
        :model="examineForm"
        label-position="left"
        label-width="150px"
        style="width: 90%; margin-left:50px;"
      >
        <el-form-item label="商户ID">
          <span>{{ examineObj.mchId }}</span>
        </el-form-item>
        <el-form-item label="商户名称">
          <span>{{ examineObj.mchName }}</span>
        </el-form-item>
        <el-form-item label="名称">
          <span>{{ examineObj.name }}</span>
        </el-form-item>
        <el-form-item label="类目 ">
          <span>{{ examineObj.caterotyDescr }}</span>
        </el-form-item>
        <el-form-item label="品牌logo ">
          <el-image
            style="width: 100px; height: 100px"
            :src="examineObj.logo"
            fit="cover"
          ></el-image>
        </el-form-item>
        <el-form-item label="品牌介绍">
          <span>{{ examineObj.content }}</span>
        </el-form-item>
        <el-divider></el-divider>
        <el-form-item label="审核结果" prop="status">
          <el-select
            v-model="examineForm.status"
            placeholder="状态"
            style="width: 100%"
            class="filter-item"
            clearable
          >
            <el-option
              v-for="item in EXAMINE_STATUS"
              :key="item.key"
              :label="item.value"
              :value="item.key"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="checkExamineVisible(false, {})">取消</el-button>
        <el-button type="primary" @click="examineOk" :loading="btnLoading"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getBrandList, editBrand, checkBrand } from "@/api/brand";
import {
  formatApiDate,
  getFileName,
  splitMenus,
  getTableThumbnailImg
} from "@/utils/utils";
import { BRAND_STATUS_CSS } from "@/utils/enumUtileCss";
import {
  DIALOG_TITLE_TYPE,
  getValue,
  BRAND_STATUS,
  EXAMINE_STATUS,
  UPLOAD_IMG_TYPE,
  BRAND_STATUS_VAL
} from "@/utils/enumUtile";
import Category from "@/views/components/category.vue";
import UploadList from "@/views/components/uploadList.vue";

export default {
  computed: {
    formatApiDate() {
      return formatApiDate;
    },
    BRAND_STATUS() {
      return BRAND_STATUS;
    },
    DIALOG_TITLE_TYPE() {
      return DIALOG_TITLE_TYPE;
    },
    EXAMINE_STATUS() {
      return EXAMINE_STATUS;
    },
    BRAND_STATUS_CSS() {
      return BRAND_STATUS_CSS;
    },
    UPLOAD_IMG_TYPE() {
      return UPLOAD_IMG_TYPE;
    },
    BRAND_STATUS_VAL() {
      return BRAND_STATUS_VAL;
    }
  },
  components: { Category, UploadList },
  filters: {},
  data() {
    return {
      list: null,
      total: 0,
      listLoading: false,
      listQuery: {
        page: 1,
        pageSize: 20,
        keyword: null,
        status: null,
        provinceId: null,
        cityId: null,
        category: null
      },
      categoryOption: [], // 主营类目
      dialogFormVisible: false,
      dialogType: "",
      rules: {
        category: [
          { required: true, message: "所属类目不能为空", trigger: "change" }
        ],
        logo: [
          { required: true, message: "品牌LOGO不能为空", trigger: "change" }
        ],
        name: [
          { required: true, message: "品牌名称不能为空", trigger: "change" }
        ]
      },
      form: {
        id: 0,
        category: null, //省份ID
        content: null, // 城市ID
        name: null,
        logo: null
      },
      btnLoading: false,
      examineVisible: false, // 审核的弹框
      examineObj: {}, // 审核的弹框
      examineRules: {
        status: [
          { required: true, message: "审核结果不能为空", trigger: "change" }
        ]
      },
      examineForm: {
        id: 0, //
        status: null
      }
    };
  },
  created() {
    this.getList();
  },
  watch: {},
  methods: {
    getValue,
    getTableThumbnailImg,
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    /**
     * 查询用户列表
     */
    getList() {
      this.listLoading = true;
      const form = this.listQuery;
      const params = {
        ...form
      };
      if (form.category && form.category.length !== 0) {
        // const categoryArr = [];
        // encapsulationMenus(form.category, categoryArr);
        params.category =
          form.category.length !== 0 ? form.category.join(",") : "";
      }
      getBrandList(params)
        .then(response => {
          this.list = response.data.entitys;
          this.total = response.data.totalCount;
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    /**
     * 获取主营类目
     * @param type
     * @param resultArr
     */
    getCategoryValueFunc(type, resultArr) {
      if (type === "formCategory") {
        this.form.category = resultArr;
      } else if (type === "queryCategory") {
        this.listQuery.category = resultArr;
      }
    },
    /**
     * 切换状态
     * @param status
     * @param editObj
     * @param type
     */
    checkDialogFormVisible(status, editObj = {}, type) {
      if (status && type === "UPDATE") {
        this.form.id = editObj.id;
        this.form.category = splitMenus(editObj.category);
        this.form.content = editObj.content;
        this.form.name = editObj.name;
        if (editObj.logo) {
          const attDataArr = [];
          attDataArr.push({
            url: editObj.logo,
            dbUrl: editObj.logo,
            name: getFileName(editObj.logo)
          });
          this.form.logo = attDataArr;
        }
      }
      if (!status) {
        this.form.id = 0;
        this.form.category = null;
        this.form.content = null;
        this.form.name = null;
        this.form.logo = null;
        this.$refs.form.resetFields();
      }
      this.dialogType = type;
      this.dialogFormVisible = status;
    },
    /**
     * 确认添加还是编辑
     */
    saveAddOrEditData() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          const form = this.form;
          // const busCategoryArr = [];
          // encapsulationMenus(form.category, busCategoryArr);
          const params = {
            content: form.content,
            name: form.name,
            category: form.category.length !== 0 ? form.category.join(",") : ""
          };
          if (form.logo && form.logo.length !== 0) {
            const urlArr = form.logo.map(obj => obj["dbUrl"]);
            params.logo = urlArr.join(",");
          }
          if (form.id && form.id !== 0) {
            params.id = form.id;
          }
          this.btnLoading = true;
          editBrand(params)
            .then(() => {
              this.getList();
              this.checkDialogFormVisible(false);
              this.$notify({
                title: "成功",
                message: "保存成功",
                type: "success",
                duration: 2000
              });
            })
            .finally(() => {
              this.btnLoading = false;
            });
        }
      });
    },

    // 审核 start
    checkExamineVisible(val, obj = {}) {
      this.examineObj = obj;
      if (obj && Object.keys(obj).length !== 0) {
        this.examineForm.id = obj.id;
      }
      this.examineVisible = val;
    },
    examineOk() {
      this.$refs["examineForm"].validate(valid => {
        if (valid) {
          const form = this.examineForm;
          const params = {
            ...form
          };
          this.btnLoading = true;
          checkBrand(params)
            .then(() => {
              this.getList();
              this.checkExamineVisible(false);
              this.$notify({
                title: "成功",
                message: "审核成功",
                type: "success",
                duration: 2000
              });
            })
            .finally(() => {
              this.btnLoading = false;
            });
        }
      });
    },
    // 审核 end

    /**
     *  获取图片的值
     * @param type
     * @param value
     */
    getImgsValueFunc(type, value) {
      if (type === "brandLogo") {
        this.form.logo = value;
      }
    }
  }
};
</script>
<style scoped lang="scss"></style>
